// eslint-disable-next-line no-console
import('./bootstrap').catch((err) => console.error(err));
